import React from 'react';
import { Box, Icon, Text, Title } from '@nimbus-ds/components';
import { IdCardIcon, UserIcon } from '@nimbus-ds/icons';
import { CustomerInterface } from 'commons/types';
import { formatCuit, useTranslationWithPrefix } from 'commons/utils';
import ClientSkeleton from './ClientSkeleton';

interface ClientProps {
  customer: CustomerInterface;
}

function Client({ customer }: ClientProps) {
  const { t } = useTranslationWithPrefix('chargebackUpload.client');

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2"
      data-testid="chargeback-upload-client"
    >
      <Title as="h4">{t('title')}</Title>
      {customer.document && (
        <Box display="flex" flexDirection="row" gap="2">
          <Icon source={<IdCardIcon />} />
          <Text fontWeight="medium">
            {t('document', {
              document:
                customer.document.length > 9
                  ? formatCuit(customer.document)
                  : customer.document,
            })}
          </Text>
        </Box>
      )}
      <Box display="flex" flexDirection="row" gap="2">
        <Icon source={<UserIcon />} />
        <Text fontWeight="medium">{customer.name}</Text>
      </Box>
    </Box>
  );
}

Client.Skeleton = ClientSkeleton;
export default Client;
